import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMembershipOverview } from "../../api/membershipOverviewApi";

const initialState = {
  duration: "",
  type: "",
  status: "",
  paymentMonthStatus: [],
  loading: false,
  error: null,
};

// Async thunk to fetch membership overview
export const fetchMembershipOverview = createAsyncThunk(
  "membershipOverview/fetchMembershipOverview",
  async (clientId, { rejectWithValue }) => {
    try {
      const data = await getMembershipOverview(clientId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const membershipOverviewSlice = createSlice({
  name: "membershipOverview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembershipOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMembershipOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.duration = action.payload?.duration;
        state.type = action.payload?.type;
        state.status = action.payload.status;
        state.paymentOverview = action.payload.paymentOverview;
        state.paymentMonthStatus = action.payload.paymentMonthStatus;
        state.firstName = action.payload.firstName;
        state.lastName = action.payload.lastName;
        state.goal = action.payload.goal;
        state.status = action.payload.status;
        state.leadId = action.payload.leadId;
        state.subscriptionEndDate = action.payload.subscriptionEndDate;
        state.clientMeasurements = action.payload.clientMeasurements;
        state.dailyIntakeRecommendation =
          action.payload.dailyIntakeRecommendation;
      })
      .addCase(fetchMembershipOverview.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export default membershipOverviewSlice.reducer;
